import '../../../../vendor/angular-elastic/elastic';

export const elasticComponentModule = 'monospaced.elastic';
